import {resolveSetupEvent} from './eventSetup';

function dateFrom(value) {
  if (value == null || value === '') return null;
  const date = typeof value.toDate === 'function' ? value.toDate() : new Date(value);
  return Number.isFinite(date.getTime()) ? date : null;
}

export function formatTeamStatsMatchTime(match, events = [], timeZone) {
  const event = resolveSetupEvent(events, match.calendarEventId || '');
  const start = dateFrom(event?.startUTC) || dateFrom(match.calendarEventStartUTC);
  const date = start || dateFrom(match.matchDate);
  if (!date) return 'Not set';
  return new Intl.DateTimeFormat(undefined, {
    day: 'numeric', month: 'short', year: 'numeric',
    ...(start ? {hour: 'numeric', minute: '2-digit', timeZoneName: 'short'} : {}),
    ...(timeZone ? {timeZone} : {}),
  }).format(date);
}
